import React from "react";
import "./subHero.css";

const SubHero = () => {
  return (
    <div className="subHero">
      <div className="container">
        <p>1000+ hires completed</p>
        <p>Pre-Seed to Series C+</p>
        <p>Executive, management, and individual contributor roles</p>
        <p>Technical and non-technical teams</p>
      </div>
    </div>
  );
};

export default SubHero;
